// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39W3D","col":"styles_col__1xR4d","fulfillmentStatus":"styles_fulfillmentStatus__1fLHV","emailCol":"styles_emailCol__2DNYg"};